export default __webpack_public_path__ + "static/media/woven.7cfeebb3.jpg";